// Types for the admin AI agent panel. Kept consistent with PLAN 2's backend
// request/response/SSE shapes.

export type AgentMessageRole = 'user' | 'assistant' | 'tool' | 'proposal';

export type ProposalTier = 'A' | 'B';
export type ProposalMethod = 'POST' | 'PUT' | 'PATCH' | 'DELETE';

// An inert action proposal the model emits; executed by the frontend on confirm
// against the EXISTING admin REST endpoint named in `endpoint`.
export interface AgentProposal {
  endpoint: string;
  method: ProposalMethod;
  payload: Record<string, any>;
  tier: ProposalTier;
  scope_summary: string;
  // Optional navigator deep-link the panel can offer.
  suggested_route?: string;
  // Set by the backend when the proposal matches a catalog action.
  action_key?: string;
  action_label?: string;
}

// Persisted message content is a JSON object; assistant/user carry {text},
// proposal carries the AgentProposal dict, tool carries a status line.
export interface AgentMessage {
  id: number;
  role: AgentMessageRole;
  content: Record<string, any>;
}

export interface AgentConversationSummary {
  id: number;
  title?: string | null;
  updated_at?: string | null;
}

export interface AgentConversationDetail {
  id: number;
  title?: string | null;
  messages: AgentMessage[];
}

// Decoded SSE events streamed from POST /admin/agent/chat.
export type AgentSSEEvent =
  | { type: 'text'; delta: string }
  | { type: 'tool_status'; tool: string; label: string }
  | { type: 'proposal'; proposal: AgentProposal }
  | { type: 'done'; conversation_id: number }
  | { type: 'error'; message: string };

export interface ChatRequest {
  message: string;
  conversation_id?: number;
  page_context?: PageContext;
}

export interface PageContext {
  route: string;
  filters?: Record<string, string>;
  selected_ids?: Array<string | number>;
}

export function isTierB(proposal: AgentProposal): boolean {
  return proposal.tier === 'B';
}
